import * as React from 'react';
import styled from "styled-components";

const SIdiom = styled.div`
  flex: 1;
  padding: 5px 20px;
  td {
    padding: 5px;
  }
`;

const Idiom = () => {
  return (
    <SIdiom>
      <h5>Idiomy</h5>

<table>
<tr><td width="20%">ale najadłem się strachu!</td><td>&iexcl;qué susto me llevé!</td></tr>
<tr><td>aż mi ślinka cieknie!</td><td>&iexcl;se me hace la boca agua!</td></tr>
<tr><td>biały jak śnieg</td><td>blanco como la nieve</td></tr>
<tr><td>brać kogoś pod włos, żartować z kogoś</td><td>tomarle el pelo a alguien (potocznie)</td></tr>
<tr><td>brak mu piątej klepki</td><td>le falta un tornillo (potocznie)</td></tr>
<tr><td>broń obosieczna</td><td>arma de doble filo</td></tr>
<tr><td>budować zamki na lodzie</td><td>hacer castillos en el aire</td></tr>
<tr><td>bujda na resorach!</td><td>&iexcl;eso es un cuento chino! (potocznie)</td></tr>
<tr><td>być bardzo zdenerwowanym</td><td>tener los nervios de punta</td></tr>
<tr><td>być bezczelnym</td><td>tener mucha cara (potocznie)</td></tr>
<tr><td>być czyimś oczkiem w głowie</td><td>ser la niña de los ojos de alguien</td></tr>
<tr><td>być czyjąś prawą ręką</td><td>ser el brazo derecho de alguien </td></tr>
<tr><td>być dumnym jak paw</td><td>hincharse como un pavo real</td></tr>
<tr><td>być głupim jak but</td><td>estar loco de remate, estar tonto de capirote</td></tr>
<tr><td>być na bieżąco</td><td>estar al día, estar al. corriente de algo</td></tr>
<tr><td>być na fali (potocznie)</td><td>estar en la onda</td></tr>
<tr><td>być nierozgarniętym</td><td>tener pocas luces</td></tr>
<tr><td>być szalonym [mieć świra]</td><td>estar como una regadera</td></tr>
<tr><td>być w negliżu [w bieliźnie]</td><td>estar en paños menores</td></tr>
<tr><td>być w pieskim humorze</td><td>estar de un humor de perros (potocznie)</td></tr>
<tr><td>być w złym humorze</td><td>estar de mala uva (potocznie)</td></tr>
<tr><td>być zwariowanym</td><td>estar loco de atar</td></tr>
<tr><td>całkowicie [na sto procent]</td><td>al cien por cien</td></tr>
<tr><td>cały i zdrowy</td><td>sano y salvo</td></tr>
<tr><td>chcieć to móc</td><td>querer es poder</td></tr>
<tr><td>chować kogoś pod kloszem</td><td>tener entre algodones a alguien</td></tr>
<tr><td>ciągnąć kogoś za język</td><td>tirarle de la lengua a alguien</td></tr>
<tr><td>co go ugryzło?</td><td>&iquest;qué mosca le ha picado?</td></tr>
<tr><td>co łaska (potocznie)</td><td>la voluntad</td></tr>
<tr><td>czas to pieniądz</td><td>el tiempo es oro</td></tr>
<tr><td>czuć się zbytecznym [niepotrzebnym]</td><td>estar de más</td></tr>
<tr><td>czysty jak łza</td><td>limpio como una patena</td></tr>
<tr><td>czytać między wierszami</td><td>leer entre líneas</td></tr>
<tr><td>darowanemu koniowi nie zagląda się w zęby</td><td>a caballo regalado no le mires el diente </td></tr>
<tr><td>do góry nogami</td><td>patas arriba</td></tr>
<tr><td>do trzech razy sztuka</td><td>a la tercera va la vencida</td></tr>
<tr><td>dobrowolnie</td><td>por las buenas</td></tr>
<tr><td>dolewać oliwy do ognia</td><td>echar aceite/leña al fuego</td></tr>
<tr><td>dopóty dzban wodę nosi, dopóki mu się ucho nie urwie</td><td>tanto va el cántaro a la fuente (hasta) que al fin se rompe</td></tr>
<tr><td>drogo mi za to zapłacisz</td><td>eso me lo vas a pagar muy caro</td></tr>
<tr><td>dusza człowiek</td><td>un pedazo de pan</td></tr>
<tr><td>figa z makiem!</td><td>&iexcl;naranjas!, &iexcl;ni hablar!</td></tr>
<tr><td>gęsiego</td><td>en fila india</td></tr>
<tr><td>głowa do góry!</td><td>&iexcl;anímate!, &iexcl;ánimo!</td></tr>
<tr><td>głupi jak but</td><td>tonto de capirote</td></tr>
<tr><td>guzik mnie to obchodzi</td><td>me importa un comino/un rábano/un pepino</td></tr>
<tr><td>habit nie czyni mnicha</td><td>el hábito no hace al monje</td></tr>
<tr><td>jak za dotknięciem czarodziejskiej różdżki</td><td>por arte de magia</td></tr>
<tr><td>jaki ojciec, taki syn</td><td>de tal palo tal astilla (de tal padre tal hijo)</td></tr>
<tr><td>jechać na gapę</td><td>ir de gorra, ir de pollizón</td></tr>
<tr><td>jeden wart drugiego</td><td>son tal para cual</td></tr>
<tr><td>jedna jaskółka nie czyni wiosny</td><td>una golondrina no hace verano</td></tr>
<tr><td>jednym pociągnięciem</td><td>de un tirón</td></tr>
<tr><td>jest chudy jak szkielet</td><td>está hecho un esqueleto</td></tr>
<tr><td>jest zerem (do niczego)</td><td>es un cero a la izquierda</td></tr>
<tr><td>kłaść uszy po sobie</td><td>agachar/bajah las orejas</td></tr>
<tr><td>kojarzyć fakty</td><td>atar cabos</td></tr>
<tr><td>kompletny wariat</td><td>loco de remate (potocznie)</td></tr>
<tr><td>koniec wieńczy dzieło</td><td>el fin corona la obra</td></tr>
<tr><td>kopalnia wiedzy</td><td>mina de información</td></tr>
<tr><td>kość niezgody</td><td>la manzana de la discordia</td></tr>
<tr><td>kosztować majątek</td><td>costar un ojo de la cara (potocznie)</td></tr>
<tr><td>kozioł ofiarny</td><td>cabeza de turco</td></tr>
<tr><td>krótko trzymać</td><td>atar corto</td></tr>
<tr><td>kto pierwszy, ten lepszy</td><td>el primero sale ganado</td></tr>
<tr><td>łączyć przyjemne z pożytecznym</td><td>unir lo útil con lo agradable</td></tr>
<tr><td>łamać sobie głowę</td><td>romperse la cabeza [los cascos]</td></tr>
<tr><td>leje jak z cebra</td><td>está lloviendo a cántaros</td></tr>
<tr><td>lepiej późno niż wcale</td><td>más vale tarde que nunca</td></tr>
<tr><td>lotem błyskawicy</td><td>como un relámpago</td></tr>
<tr><td>mam lukę w pamięci</td><td>se me quedó la mente</td></tr>
<tr><td>mieć coś na końcu języka</td><td>tener algo en la punta de la lengua</td></tr>
<tr><td>mieć gęsią skórkę</td><td>tener carne de gallina</td></tr>
<tr><td>mieć głowę w chmurach</td><td>estar en la luna</td></tr>
<tr><td>mieć nie po kolei w głowie</td><td>estar mal de la cabeza</td></tr>
<tr><td>mieć plecy</td><td>tener enchufe, tener palanca </td></tr>
<tr><td>mieć ponurą minę</td><td>tener cara de pocos amigos (potocznie)</td></tr>
<tr><td>mieć ściśnięte gardło</td><td>tener el nudo en la garganta</td></tr>
<tr><td>milczeć jak grób</td><td>ser una tumba</td></tr>
<tr><td>mól książkowy</td><td>el ratón de biblioteca</td></tr>
<tr><td>mówić ciągle o tym samym</td><td>estar siempre con la misma canción</td></tr>
<tr><td>na głowę, na osobę</td><td>por barba (potocznie)</td></tr>
<tr><td>na golasa</td><td>en cueros (potocznie)</td></tr>
<tr><td>na jedno wychodzi</td><td>viene a ser lo mismo </td></tr>
<tr><td>na łonie natury</td><td>en el seno de la naturaleza </td></tr>
<tr><td>na oścież (przymiotnik: parzysty)</td><td>de par en par</td></tr>
<tr><td>na własną rękę</td><td>por su propia cuenta (potocznie)</td></tr>
<tr><td>na wszelki wypadek</td><td>por si las moscas (potocznie)</td></tr>
<tr><td>nadstawiać ucha</td><td>aguzar las orejas</td></tr>
<tr><td>nadstawić ucha [pilnie słuchać]</td><td>prestar oídos</td></tr>
<tr><td>natrzeć komuś uszu</td><td>calentarle las orejas a alguien </td></tr>
<tr><td>natura ciągnie wilka do lasu</td><td>la cabra tira al monte</td></tr>
<tr><td>ni stąd, ni zowąd</td><td>de buenas a primeras</td></tr>
<tr><td>nic mnie to nie obchodzi</td><td>me importa un comino</td></tr>
<tr><td>nic nie rozumiem</td><td>no entiendo ni torta (potocznie)</td></tr>
<tr><td>nie cierpię go</td><td>me cae gordo (potocznie)</td></tr>
<tr><td>nie ma mowy!</td><td>&iexcl;ni hablar!</td></tr>
<tr><td>nie ma o czym mówić!</td><td>&iexcl;no tiene importancia!</td></tr>
<tr><td>nie mogę na niego patrzeć</td><td>no puedo verle ni en pintura (potocznie)</td></tr>
<tr><td>nie owijać w bawełnę</td><td>no andarse con rodeos </td></tr>
<tr><td>nie taki diabeł straszny, jak go malują</td><td>no es tan feo diablo como lo pintan</td></tr>
<tr><td>nie wszystko złoto, co się świeci</td><td>no es oro todo lo que reluce</td></tr>
<tr><td>nieszczęścia chodzą parami</td><td>las desgracias nunca vienen solas</td></tr>
<tr><td>nudzić się jak mops</td><td>aburrirse como una ostra</td></tr>
<tr><td>obiecywać złote góry</td><td>prometer el oro y el moro</td></tr>
<tr><td>od stóp do głów</td><td>de pies a cabeza</td></tr>
<tr><td>odpukać w niemalowane drzewo</td><td>tocar madera</td></tr>
<tr><td>oka nie zmrużyłem przez całą noc</td><td>no pegué ojo en toda la noche</td></tr>
<tr><td>ona jest kłębkiem nerwów</td><td>está hecha un manojo de nervios</td></tr>
<tr><td>orzeł czy reszka?</td><td>&iquest;cara o cruz?</td></tr>
<tr><td>palce lizać</td><td>es para chuparse los dedos</td></tr>
<tr><td>pańskie oko konia tuczy</td><td>el ojo del amo engorda el caballo</td></tr>
<tr><td>pasować jak ulał</td><td>venir como anillo al dedo</td></tr>
<tr><td>pękać ze śmiechu</td><td>reventar de risa</td></tr>
<tr><td>pełną parą</td><td>a todo tren</td></tr>
<tr><td>pierwszy rzut oka</td><td>a primera vista</td></tr>
<tr><td>płakać jak bóbr</td><td>llorar como una Magdalena</td></tr>
<tr><td>po burzy świeci słońce</td><td>después de la tempestad, buen tiempo</td></tr>
<tr><td>po nitce do kłębka</td><td>por el hilo se saca el ovillo</td></tr>
<tr><td>pod moim nosem</td><td>en mis propias narices (potocznie)</td></tr>
<tr><td>pół biedy!</td><td>&iexcl;menos mal!</td></tr>
<tr><td>połknąć haczyk</td><td>morder [picar] el anzuelo</td></tr>
<tr><td>pomyśleć</td><td>darle al coco</td></tr>
<tr><td>popaść w kłopoty, czuć się zakłopotanym</td><td>verse en un aprieto</td></tr>
<tr><td>poruszyć niebo i ziemię</td><td>remover cielo y tierra</td></tr>
<tr><td>powtarzać coś jak papuga</td><td>repetir algo como un loro</td></tr>
<tr><td>pozory mylą</td><td>las apariencias engañan</td></tr>
<tr><td>prędzej czy później</td><td>tarde o temprano</td></tr>
<tr><td>prosić o gwiazdkę z nieba [żądać rzeczy niemożliwych]</td><td>pedir peras al olmo</td></tr>
<tr><td>przebrać miarę</td><td>pasarse de la raya</td></tr>
<tr><td>przespać się z problemem [sen przynosi dobrą radę]</td><td>consultarlo con la almohada</td></tr>
<tr><td>przyjąć (coś) za pewnik</td><td>dar por sentado</td></tr>
<tr><td>przyjemnych snów</td><td>que sueñes con los angelitos</td></tr>
<tr><td>raz dwa, w jednej chwili</td><td>en menos que canta un gallo</td></tr>
<tr><td>robić coś po wariacku</td><td>hacer algo a lo loco</td></tr>
<tr><td>robić dobrą minę do złej gry</td><td>poner a mal tiempo buena cara </td></tr>
<tr><td>robić wielkie oczy</td><td>poner unos ojos como platos</td></tr>
<tr><td>robić z kogoś balona (potocznie) [nabijać się z kogoś]</td><td>tomarle el pelo a alguien</td></tr>
<tr><td>rozmyślać, pracować głową</td><td>comerse el coco</td></tr>
<tr><td>rzucać kłody pod nogi</td><td>poner trabas</td></tr>
<tr><td>ściany mają uszy</td><td>las paredes oyen</td></tr>
<tr><td>siedzieć z założonymi rękami</td><td>estar con los brazos cruzados</td></tr>
<tr><td>śmiać się do rozpuku</td><td>reírse a carcajadas</td></tr>
<tr><td>śmiertelnie blady (potocznie)</td><td>blanco como el papel</td></tr>
<tr><td>spać jak kamień</td><td>dormir como un tronco</td></tr>
<tr><td>spać spokojnie</td><td>dormir a pierna suelta (potocznie)</td></tr>
<tr><td>spocząć na laurach</td><td>dormirse en los laureles</td></tr>
<tr><td>stać na wysokości zadania</td><td>estar a la altura de las circunstancias</td></tr>
<tr><td>stracić orientację [zagubić się]</td><td>perder el norte</td></tr>
<tr><td>ten się śmieje, kto się śmieje ostatni</td><td>ríe mejor quien ríe el último</td></tr>
<tr><td>to bardzo dobry człowiek</td><td>es un pedazo de pan</td></tr>
<tr><td>to bardzo łatwe</td><td>esto es coser y cantar</td></tr>
<tr><td>to dziecinnie proste</td><td>es un juego de niños</td></tr>
<tr><td>to jasne jak słońce</td><td>está más claro que el agua</td></tr>
<tr><td>to nie ma nic do rzeczy</td><td>eso no viene a cuento</td></tr>
<tr><td>to się rozumie samo przez się</td><td>ni que decir tiene</td></tr>
<tr><td>trząść się jak galareta</td><td>estar hecho un flan (potocznie)</td></tr>
<tr><td>twardy jak skała</td><td>firme como una roca</td></tr>
<tr><td>typ spod ciemnej gwiazdy</td><td>un individuo con muy mal aspecto, un tipo sospechoso</td></tr>
<tr><td>ubawić się po pachy</td><td>divertirse a base de bien</td></tr>
<tr><td>udawać głupiego</td><td>hacerse el tonto</td></tr>
<tr><td>upiec dwie pieczenie na jednym ogniu</td><td>matar dos pájaros de uno tiro</td></tr>
<tr><td>uratować się w ostatniej chwili</td><td>salvarse por los pelos (potocznie)</td></tr>
<tr><td>urwać się z choinki</td><td>caerse de la luna</td></tr>
<tr><td>ustatkować się</td><td>sentar la cabeza</td></tr>
<tr><td>w głowie mi się to nie mieści</td><td>eso no me cabe en la cabeza</td></tr>
<tr><td>w mgnieniu oka</td><td>en un abrir y cerrar de ojos</td></tr>
<tr><td>w złym tonie</td><td>fuera de tono </td></tr>
<tr><td>wiedzieć coś z dobrego źródła</td><td>saber algo de buena fuente [de buena tinta]</td></tr>
<tr><td>wiele hałasu o nic</td><td>mucho ruido y pocas nueces</td></tr>
<tr><td>wiercipięta</td><td>culo de mal asiento </td></tr>
<tr><td>włosy stają mu dęba na głowie</td><td>se le ponen los pelos de punta</td></tr>
<tr><td>wolnoć Tomku w swoim domku</td><td>cada cual es rey en su casa</td></tr>
<tr><td>wpaść na kogoś</td><td>darse de narices con alguien (potocznie)</td></tr>
<tr><td>wpaść w czyjeś sieci [w pułapkę]</td><td>caer en las redes de alguien</td></tr>
<tr><td>wstać lewą nogą</td><td>levantarse con el pie izquierdo</td></tr>
<tr><td>wtykać nos [wtrącać się]</td><td>meter las narices en algo (potocznie)</td></tr>
<tr><td>wtykać nos w cudze sprawy</td><td>meter las narices en algo</td></tr>
<tr><td>wyprowadzić kogoś z równowagi</td><td>sacar de quicio a alguien</td></tr>
<tr><td>z całą pewnością</td><td>a ciencia cierta</td></tr>
<tr><td>z całego serca</td><td>de todo corazón</td></tr>
<tr><td>z otwartymi ramionami</td><td>con los brazos abiertos</td></tr>
<tr><td>z wielkim trudem</td><td>a duras penas</td></tr>
<tr><td>z zimną krwią</td><td>a sangre fría</td></tr>
<tr><td>za darmo, bezinteresownie</td><td>por amor al arte</td></tr>
<tr><td>za jednym zmachem</td><td>de un tirón</td></tr>
<tr><td>za zamkniętymi drzwiami</td><td>a puerta cerrada </td></tr>
<tr><td>zaciskać pasa</td><td>apretarse el cinturón</td></tr>
<tr><td>zacisnąć pasa</td><td>apretar el cinturón</td></tr>
<tr><td>zacząć od zera</td><td>partir de cero</td></tr>
<tr><td>zaczerwienić się jak burak</td><td>ponerse (colorado) como un tomate</td></tr>
<tr><td>zamęczać gadaniem (próbować przekonać kogoś)</td><td>comerle el coco a alguien</td></tr>
<tr><td>zamknąć się w swej skorupie</td><td>meterse en su caparazón</td></tr>
<tr><td>zaślepiony gniewem</td><td>ciego de ira</td></tr>
<tr><td>zawracać głowę (potocznie)</td><td>dar la lata</td></tr>
<tr><td>zawsze robi to, na co ma ochotę</td><td>siempre hace su santa voluntad</td></tr>
<tr><td>złamać komuś serce</td><td>partirle el corazón a alguien</td></tr>
<tr><td>zostawić kogoś na lodzie</td><td>dejar plantado a alguien</td></tr>
<tr><td>żyć jak pies z kotem</td><td>vivir como perros y gatos</td></tr>
<tr><td>żywy portret ojca [wykapany ojciec]</td><td>es el vivo retrato de su padre</td></tr>
</table>
    </SIdiom>
  )
};

export default Idiom;